import React from "react";
import { Input, InputWrapper, Wrapper } from "./style";
const Com2 = () => {
  return (
    <Wrapper>
      <InputWrapper>
        <Input placeholder="궁금한 사항을 입력해주세요" />
        <img loading="lazy" src="/assets/img/Support_2.svg" alt="" />
      </InputWrapper>
    </Wrapper>
  );
};

export default Com2;
